import Vue from 'vue'
import vuetify from './plugins/vuetify'
import VueI18n from 'vue-i18n'
import VueGtag from 'vue-gtag'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import VueAxios from 'vue-axios'
import '@mdi/font/css/materialdesignicons.css'

Vue.config.productionTip = false

Vue.use(VueAxios, axios)

Vue.use(VueI18n)
const i18n = new VueI18n({
  locale: 'ja',
  messages: {
    'ja': require('./locales/ja.json'),
    'en': require('./locales/en.json'),
  }
})

Vue.use(VueGtag, {
  config: {
    id: process.env.VUE_APP_GA_ID,
    params: {
      send_page_view: false
    }
  }
});

new Vue({
  vuetify,
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
